import { Components } from "appworks/components/components";
import { gameState } from "appworks/model/game-state";
import { Gameplay } from "appworks/model/gameplay/gameplay";
import { TGRFakeSymbolValueComponent } from "components/tgr-fake-symbol-value";
import { TGRMatrixComponent } from "components/tgr-matrix";
import { gameLayers } from "game-layers";
import { SpinRecord } from "slotworks/model/gameplay/records/spin-record";
import { slotDefinition } from "slotworks/model/slot-definition";

export function UpdateRandomMultipliersOnReelsets(): void {
    const gameplay: Gameplay = gameState.getCurrentGame();

    slotDefinition.reelsets.forEach((reelset: string[][], name: string) => {
        slotDefinition.reelsets.set(name, reelset.map((reel: string[]) => reel.map((id: string) =>
            /^QH.*/.test(id) ? Components.get(TGRFakeSymbolValueComponent).getFakeQHSymbolId() : id
        )));
    });

    const matrixComponent: TGRMatrixComponent = Components.get(TGRMatrixComponent);
    gameLayers.MatrixContent.setScene("other").then(() => {
        matrixComponent.change("default", slotDefinition.matrixGrid, null, slotDefinition.reelsets.get("base"));
    });

    if (gameplay.hasRecords()) {
        const record = gameplay.getCurrentRecord() as SpinRecord;
        matrixComponent.jumpToGrid(record.grid);
    }
}
